import { generateCss } from "@/lib/canvas/styles";
import { configStore, globalStore } from "@/store/store-accessor";
import { addOrUpdateGeneratedStylesInCanvasHead } from "@/lib/canvas/assets/css-in-head";
import { addJavaScriptsInSettingsToHead } from "@/lib/canvas/assets/js-in-head";
import { getPresetCssTemplateCacheKey } from "@/lib/twig/twig";
import { replaceVariablesInString } from "@/oxygen/variables/lib/utils";

// If you update this function, also update the one in renderer.php with the same name
export function getBuilderSelectorPrefix() {
  return configStore.builderMode === "oxygen" ? "" : ".breakdance";
}

export function handleGlobalSettingsChanged(canvasDocument: Document) {
  const css = generateCss(
    globalStore.globalProperties,
    configStore.breakpoints,
    configStore.globalSettingsControlsAndTemplate.template,
    {},
    configStore.globalSettingsControlsAndTemplate
      .propertyPathsToWhitelistInFlatProps
  );

  addOrUpdateGeneratedStylesInCanvasHead(
    canvasDocument,
    "global-settings",
    css
  );

  addJavaScriptsInSettingsToHead(canvasDocument, globalStore.globalSettings);
}

export function handlePresetsChanged(canvasDocument: Document) {
  if (configStore.builderMode === "oxygen") return;

  const css = globalStore.presets
    .map(preset => {
      const element = configStore.element(preset.availableForType);

      if (!element) {
        return "";
      }

      return generateCss(
        { design: preset.design },
        configStore.breakpoints,
        element.cssTemplate,
        {
          selector: `.breakdance .bde-preset-${preset.id}`
        },
        element.propertyPathsToWhitelistInFlatProps,
        0,
        getPresetCssTemplateCacheKey(element, preset.id)
      );
    })
    .join(" ");

  addOrUpdateGeneratedStylesInCanvasHead(canvasDocument, "presets", css);
}

export function handleSelectorsChanged(canvasDocument: Document) {
  const css = globalStore.cssSelectors.reduce(
    (acc, cssSelector) =>
      acc +
      generateCss(
        cssSelector.properties,
        configStore.breakpoints,
        configStore.classTemplate,
        {
          selector:
            cssSelector.type === "class"
              ? `.breakdance ${cssSelector.name}`
              : cssSelector.name
        }
      ),
    ""
  );

  addOrUpdateGeneratedStylesInCanvasHead(canvasDocument, "selectors", css);
}

export function handleVariablesChanged(canvasDocument: Document) {
  const css = replaceVariablesInString(
    generateCss(
      {
        variables: globalStore.variables
      },
      configStore.breakpoints,
      configStore.variablesControlsAndTemplate.template,
      {},
      configStore.variablesControlsAndTemplate
        .propertyPathsToWhitelistInFlatProps
    ),
    globalStore.variables
  );

  addOrUpdateGeneratedStylesInCanvasHead(canvasDocument, "variables", css);
}
